var e = require("react"),
  n = function () {
    return "undefined" != typeof window ? Number((.01 * window.innerHeight).toFixed(2)) : 0;
  },
  t = 0;
module.exports = function () {
  var r = e.useState(n()),
    o = r[0],
    u = r[1],
    i = e.useCallback(function () {
      var e = n();
      document.documentElement.style.setProperty("--vh", e + "px"), u(e);
    }, [u]);
  return e.useEffect(function () {
    return t += 1, i(), window.addEventListener("resize", i), function () {
      window.removeEventListener("resize", i), 0 == (t -= 1) && document.documentElement.style.removeProperty("--vh");
    };
  }, [i]), o;
};